import angular from 'angular';
import moment from 'moment';
import 'moment-range';
import 'moment-timezone';
import DatapointSelectorController from './datapointSelector/datapoint.selector.controller';
import DatapointSelectorHtml from './datapointSelector/datapoint.selector.html';

import { ParamterNames, ConstantValues } from '../models/report.model';

const dataLayer = window.dataLayer || [];

const gtmEvents = {
  analyticsViewReport: 'analyticsViewReport',
  analyticsDownloadReport: 'analyticsDownloadReport',
  analyticsScheduleReport: 'analyticsScheduleReport',
};

const DATE_RANGE_STRINGS = {
  _7D: { value: '7d', tooltip: 'Last 7 days' },
  _30D: { value: '30d', tooltip: 'Last 30 days' },
  _90D: { value: '90d', tooltip: 'Last 90 days' },
  _MTD: { value: 'MTD', tooltip: 'Month to date' },
  _CUSTOM: {
    value: 'Custom',
    tooltip: 'Select a custom date window from the past 13 months for up to 90 days',
  },
  _CUSTOM_HOURLY: {
    value: 'Custom',
    tooltip: 'Only last 4 weeks of data is available',
  },
  _1W: { value: 'Last 1 Week', tooltip: 'Last 1 Week' },
  _2W: { value: 'Last 2 Weeks', tooltip: 'Last 2 Weeks' },
  _3W: { value: 'Last 3 Weeks', tooltip: 'Last 3 Weeks' },
  _4W: { value: 'Last 4 Weeks', tooltip: 'Last 4 Weeks' },
};

const HOURLY_ASSET_UTILIZATION = 'Hourly Asset Utilization';

export default function ReportsDetailController(
  $scope,
  $sce,
  $q,
  $stateParams,
  usersService,
  appSettings,
  $uibModal,
  $rootScope,
  gettextCatalog,
  CSVDataExportService,
  reportingService,
  EquipmentService,
) {
  'ngInject';

  const vm = this;
  const DATE_FORMAT = 'YYYY-MM-DD';
  // const supportedLanguages = new Set(['fr', 'de']);

  function getReportPath() {
    // Quick hack for now just to prove that we can do translated reports.
    // Today we only have translated version for Asset Utilization Summary report.
    // In reality, this will be data-driven somehow.

    // Support for other languages has been removed
    // The languages that were supported for Asset Utilization Summary
    // only retrieved an empty report
    // All reports are now redirected to english.

    // const currentLanguage = gettextCatalog.currentLanguage;
    // let reportPath = $scope.reportPath;

    // if ($scope.reportName.includes('Asset Utilization Summary') && supportedLanguages.has(currentLanguage))
    // reportPath = `${reportPath} ${currentLanguage}`;
    // return reportPath;

    return $scope.reportPath;
  }

  vm.getReportPath = getReportPath;
  $scope.csvReport = {
    contacts: [],
  };
  $scope.maxEmails = 10;
  $scope.csvGenerated = false;
  $scope.reportName = $stateParams.reportName;
  $scope.reportId = $stateParams.reportId;
  $scope.isLoadingParameters = false;
  $scope.dateRangeType = undefined;
  $scope.attrs = {};

  $rootScope.datapointsSelected = {};
  $rootScope.selectedAssetsForDataPoints = [];
  $rootScope.selectDataPointsButtonEnabled = false;
  // report parameters
  $scope.reportParam = [];
  $scope.exportList = [];
  $scope.title = $scope.reportName;
  $scope.typeName = $stateParams.typeName;
  $scope.reportGenerated = false;
  $scope.btn = {};
  $scope.date = {};
  $scope.unitOfMeasure = '';
  $scope.maxSelection = 0;
  $scope.pressurethreshold = {};
  $scope.dropDate = false;

  // use to disable or enable button
  $scope.isValid = {
    startDate: false,
    endDate: false,
    dateDrop: true,
  };

  // because most our report will require asset except Arcoler report
  $scope.selectedAttributes = {
    dateRange: undefined,
    selectedAssets: [],
    reportParameters: {},
    typeName: $scope.typeName,
    reportDoesNotRequireAssets: false,
  };

  if ($rootScope.currentUser.email) {
    $scope.csvReport.contacts.push({
      email: $rootScope.currentUser.email,
    });
  }

  $scope.report = {
    name: $scope.reportName,
  };

  $scope.hideScheduleButton = function () {
    return (
      !$scope.dropDate ||
      ($scope.dateRangeType && $scope.dateRangeType.toLowerCase() === 'weekly') ||
      $scope.reportName === HOURLY_ASSET_UTILIZATION
    );
  };
  // Gets the path of the template for the parameters, some inputs are hidden from the UI
  // this is because we need form inputs to be able to POST to a iFrame
  $scope.getParamPath = function (name) {
    if (name.indexOf('drop_') === 0) {
      return 'pages/reports/reportview/reportparameters/_form.drop_.html';
    }
    if (name === 'dt_EndDate') {
      $scope.dateRangeType = $scope.dateRangeType || '';
      return `pages/reports/reportview/reportparameters/_form.drop_DateRange${$scope.dateRangeType}.html`;
    }
    if (name === 'AssetList') {
      return 'pages/reports/reportview/reportparameters/_form.AssetList.html';
    }
    if (name === 'UnitOfMeasure') {
      $scope.unitOfMeasure = usersService.currentUser().claims.data.unitOfMeasure;
      return 'pages/reports/reportview/reportparameters/_form.user_unit_of_measure.html';
    }
    if (name === 'UserUOM') {
      // not sure if needed keeping around for legacy purposes
      $scope.userUOM = usersService.currentUser().claims.data.unitOfMeasure;
      return 'pages/reports/reportview/reportparameters/_form.user_uom.html';
    }
    if (name === 'TimeZoneId') {
      $scope.timeZoneId = usersService.currentUser().claims.data.timezone;
      return 'pages/reports/reportview/reportparameters/_form.time_zone_id.html';
    }
    if (name === 'UserTZ') {
      $scope.userTZ = moment().format('z');
      return 'pages/reports/reportview/reportparameters/_form.user_time_zone.html';
    }
    if (name === 'UserName') {
      $scope.userName = usersService.currentUser().username;
      return 'pages/reports/reportview/reportparameters/_form.user_name.html';
    }
    if (name === 'AccountId') {
      $scope.accountId = parseInt(usersService.currentUser().account.id);
      return 'pages/reports/reportview/reportparameters/_form.account_id.html';
    }
    if (name === 'LowPressureThreshold') {
      return 'pages/reports/reportview/reportparameters/_form.low_pressure_threshold.html';
    }
    if (name === 'HighPressureThreshold') {
      return 'pages/reports/reportview/reportparameters/_form.high_pressure_threshold.html';
    }
    if (name === 'Currency') {
      return 'pages/reports/reportview/reportparameters/_form.dropdown.html';
    }
    if (name === 'FuelPrice') {
      return 'pages/reports/reportview/reportparameters/_form.number_input_textbox.html';
    }
    if (name === ParamterNames.Plant) {
      return 'pages/reports/reportview/reportparameters/_form.attrsType.html';
    }
    if (name === ParamterNames.SecurityContextId) {
      return 'pages/reports/reportview/reportparameters/_form.hiddenInput.html';
    }
    if (name === ParamterNames.Datapoint) {
      return 'pages/reports/reportview/reportparameters/_form.DatapointSelector.html';
    }
    return '';
  };

  $scope.iframeReportCallBack = function () {
    if ($scope.isLoadingParameters) return;
    $scope.reportLoading = false;
    $scope.reportGenerated = true;
    $scope.$apply();
  };

  // get the report parameters
  const getReportParameters = function () {
    $scope.isLoadingParameters = true;

    reportingService
      .getReportById($stateParams.reportId)
      .then(
        function (reportData) {
          $scope.attrs = reportData.attrs;
          $scope.prefilter = reportData.attrs.prefilter;
          $scope.dateRangeType = reportData.attrs.dateRange || '';
          $scope.parametersData = reportData.parameters;
          $scope.reportPath = reportData.viewPath;
          $scope.selectedAttributes.reportPath = $scope.reportPath;
          $scope.selectedAttributes.reportDoesNotRequireAssets = !reportData.requiredAssets;
          $scope.reportName = reportData.name;
          $scope.exportListData = reportData.exportOptions;
          // url to pass to the iframe
          const rp = `${appSettings.VikingEndpoint}/default?path=${encodeURIComponent(
            getReportPath(),
          )}`;
          $scope.reportsPath = $sce.trustAsResourceUrl(rp);
          getReportExportTypes();

          for (let i = 0; i < $scope.parametersData.length; i++) {
            if ($scope.parametersData[i].name === 'MaxSelection') {
              $scope.maxSelection = $scope.parametersData[i].defaultValues[0];
            } else if ($scope.parametersData[i].name === 'UnitOfMeasure') {
              $scope.unitOfMeasure = $rootScope.currentUser.claims.data.unitOfMeasure;
            } else if ($scope.parametersData[i].name === 'drop_DateRange') {
              if (!reportData.doNotSupportCustomRang) {
                $scope.parametersData[i].validValues.push({
                  label: 'Custom',
                  value: '5',
                });
              }
              $scope.dropDate = true;
              // Hourly Asset Utilization report doesn't need to show the Custom button,
              // so its hidden ony for this report.
              if ($scope.reportName === HOURLY_ASSET_UTILIZATION) {
                $scope.parametersData[i].hidden = true;
              }
            } else if ($scope.parametersData[i].name === 'HighPressureThreshold') {
              $scope.parametersData[i]._selected = parseInt(
                $scope.parametersData[i].defaultValues[0],
              );
              $scope.pressurethreshold.highid = i;
            } else if ($scope.parametersData[i].name === 'dt_StartDate') {
              $scope.parametersData[i]._selected = moment().format(DATE_FORMAT);
            } else if ($scope.parametersData[i].name === 'LowPressureThreshold') {
              $scope.parametersData[i]._selected = parseInt(
                $scope.parametersData[i].defaultValues[0],
              );
              $scope.pressurethreshold.lowid = i;
            } else if ($scope.parametersData[i].name === ParamterNames.Plant) {
              [$scope.parametersData[i]._selected = ConstantValues.All] =
                $scope.parametersData[i].defaultValues || [];
              reportingService
                .getAttributeParamValidValues(ParamterNames.Plant)
                .then((validValues) => {
                  $scope.parametersData[i].validValues = validValues;
                });
            } else if ($scope.parametersData[i].name === ParamterNames.SecurityContextId) {
              const { contextId } = usersService.currentUser();
              $scope.parametersData[i]._selected = contextId;
            } else if ($scope.parametersData[i].name === 'Currency') {
              $scope.parametersData[i]._selected = $scope.parametersData[i].defaultValues[0];
            }
          }
        },
        function () {},
      )
      .finally(function () {
        $scope.isLoadingParameters = false;
        $scope.$emit('$viewContentLoaded');
      });
  };

  // get formats this report can export
  const getReportExportTypes = function () {
    for (let i = 0; i < $scope.exportListData.length; i++) {
      const obj = {
        label: $scope.exportListData[i],
        format: $scope.exportListData[i],
        destination: $scope.reportPath,
      };
      $scope.exportListData[i] = obj;
    }
    return $scope.exportListData;
  };

  //  verb : 'GET'|'POST'
  //  target : an optional opening target (a name, or "_blank"), defaults to "_self"
  const reportDownloadParams = (verb, url, data, target) => {
    const form = document.createElement('form');
    form.action = url;
    form.method = verb;
    form.target = target || '_self';
    if (data) {
      for (let i = 0; i < data.length; i += 1) {
        const input = document.createElement('textarea');
        input.name = data[i].name;
        input.value = data[i].value;
        form.appendChild(input);
      }
    }
    form.style.display = 'none';
    document.body.appendChild(form);
    form.submit();
  };

  $scope.downloadReport = (exportFormat) => {
    if ($scope.requiredFieldsFilled()) {
      const url = `${appSettings.VikingEndpoint}/Export?path=${encodeURIComponent(
        getReportPath(),
      )}&format=${encodeURIComponent(exportFormat)}`;

      const formData = $('form#reportForm').serializeArray();

      dataLayer.push({
        event: gtmEvents.analyticsDownloadReport,
        data: {
          ReportName: $scope.reportName,
          ...formData,
        },
      });

      reportDownloadParams('POST', url, formData, '_blank');
    }
  };

  $scope.getIconForFormat = function (format) {
    format = format.toLowerCase();
    if (format === 'excel') {
      return 'fa fa-file-excel-o';
    }
    if (format === 'pdf') {
      return 'fa fa-file-pdf-o';
    }
    return null;
  };

  const checkIfAnyAssetsSelected = function () {
    if (!$scope.parametersData || !$scope.reportForm) return false;

    const assetList = $scope.parametersData.find(function (param) {
      return param.name === 'AssetList';
    });
    if (!assetList) return false;

    return assetList._selected && Object.keys(assetList._selected).length > 0;
  };

  // Check to see if all of the required fields are field in
  $scope.requiredFieldsFilled = function () {
    let bool = true;
    // check for having any assets selected before making the array empty for proper enabling/disabling data points button
    $rootScope.selectDataPointsButtonEnabled = checkIfAnyAssetsSelected();

    $scope.selectedAttributes.selectedAssets = [];
    $rootScope.selectedAssetsForDataPoints = [];
    if (!$scope.parametersData) return false;
    if (!$scope.reportForm || $scope.reportForm.$invalid) return false; // handle undefined and null pointers

    for (let i = 0; i < $scope.parametersData.length; i++) {
      const param = $scope.parametersData[i];
      if (param.name === 'drop_DateRange') {
        for (let j = 0; j < param.validValues.length; j++) {
          const item = param.validValues[j];
          switch (item.label) {
            case '7d':
              item.tooltip = gettextCatalog.getString('Last 7 days');
              break;
            case 'MTD':
              item.tooltip = gettextCatalog.getString('Month to date');
              break;
            case '30d':
              item.tooltip = gettextCatalog.getString('Last 30 days');
              break;
            case '90d':
              item.tooltip = gettextCatalog.getString('Last 90 days');
              break;
            case DATE_RANGE_STRINGS._CUSTOM.value:
              if ($scope.reportName === HOURLY_ASSET_UTILIZATION) {
                item.tooltip = gettextCatalog.getString(DATE_RANGE_STRINGS._CUSTOM_HOURLY.tooltip);
              } else {
                item.tooltip = gettextCatalog.getString(DATE_RANGE_STRINGS._CUSTOM.tooltip);
              }
              break;
            case DATE_RANGE_STRINGS._1W.value:
              item.tooltip = gettextCatalog.getString(DATE_RANGE_STRINGS._1W.tooltip);
              break;
            case DATE_RANGE_STRINGS._2W.value:
              item.tooltip = gettextCatalog.getString(DATE_RANGE_STRINGS._2W.tooltip);
              break;
            case DATE_RANGE_STRINGS._3W.value:
              item.tooltip = gettextCatalog.getString(DATE_RANGE_STRINGS._3W.tooltip);
              break;
            case DATE_RANGE_STRINGS._4W.value:
              item.tooltip = gettextCatalog.getString(DATE_RANGE_STRINGS._4W.tooltip);
              break;
            default:
              break;
          }
        }
        if (param._selected) {
          const selectedDateOption =
            (param.validValues || []).find((op) => op.value === param._selected) || {};
          $scope.selectedAttributes.dateRange = {
            id: param._selected,
            label: selectedDateOption.label,
            reportDateName: selectedDateOption.tooltip,
          };
        }
        // if there is no default value for the drop_dateRange component and another value has not been selected
        // set the default value to be 0 so the "7 days" option is selected automatically
        else if (
          param.defaultValues.length <= 0 &&
          !param._selected &&
          param.name === 'drop_DateRange'
        ) {
          param.defaultValues.push('1');
        }
      } else if (
        param.name === 'UserTZ' ||
        param.name === 'UserUOM' ||
        param.name === 'UserName' ||
        param.name === 'TimeZoneId' ||
        param.name === 'date_PickRange'
      ) {
        continue;
      } else if (param.name === 'AssetList') {
        if (!param._selected || Object.keys(param._selected).length <= 0) {
          bool = false;
          continue;
        } else {
          const keys = Object.keys(param._selected);
          for (let x = 0; x < keys.length; x++) {
            $scope.selectedAttributes.selectedAssets.push({
              id: keys[x],
              name: param._selected[keys[x]].name,
            }); // param._selected[key]);
            $rootScope.selectedAssetsForDataPoints.push({
              id: keys[x],
              name: param._selected[keys[x]].name,
            });
          }
        }
        continue;
      } else if (
        param.name === 'dt_StartDate' &&
        param.required &&
        !param._selected &&
        $scope.dateRangeType.indexOf('Weekly') !== -1
      ) {
        return false;
      } else if (
        param.name === 'dt_EndDate' &&
        param.required &&
        !param._selected &&
        $scope.dateRangeType.indexOf('Weekly') !== -1
      ) {
        return false;
      } else if (param.nullable) {
        // If the parameter is nullable we dont' need to verify it.
        continue;
      } else if (param.name === 'FuelPrice') {
        if (param._selected === '' || param._selected === undefined) {
          bool = false;
          continue;
        }
      }
    }
    if ($scope.numSelectedDataPoints() <= 0 && $scope.reportName === HOURLY_ASSET_UTILIZATION) {
      return false;
    }
    return bool;
  };

  // INIT METHODS
  getReportParameters();

  // WATCH
  $scope.$watch('btn.radio', function (val) {
    if (val != null) {
      for (let i = 0; i < $scope.parametersData.length; i++) {
        if (
          ($scope.parametersData[i]._selected && $scope.parametersData[i].name === 'dt_EndDate') ||
          $scope.parametersData[i].name === 'dt_StartDate'
        ) {
          $scope.parametersData[i]._selected = null;
          $scope.isValid.startDate = false;
          $scope.isValid.endDate = false;
          $scope.isValid.dateDrop = true;
        }
      }
      $scope.date.end = null;
      $scope.date.start = null;
    }
  });

  $scope.$watch('date.end', function (val) {
    if ($scope.parametersData) {
      for (let i = 0; i < $scope.parametersData.length; i++) {
        if (
          $scope.parametersData[i]._selected &&
          $scope.parametersData[i].name === 'drop_DateRange'
        ) {
          $scope.isValid.dateDrop = false;
        }

        if ($scope.parametersData[i].name === 'dt_EndDate') {
          if (val) {
            $scope.parametersData[i]._selected = moment(val).format(DATE_FORMAT);
          } else {
            $scope.parametersData[i]._selected = null;
          }
          $scope.parametersData[i].required = true; // this is required for the date.end or why the user should access this control

          $scope.isValid.startDate = $scope.isValid.endDate =
            $scope.date.start && $scope.date.end ? $scope.date.end >= $scope.date.start : false;

          if ($scope.reportForm && $scope.reportForm.dt_EndDate) {
            $scope.reportForm.dt_EndDate.$error.dateLowerThan = $scope.isValid.endDate;
          }
        }
      }
    }
  });

  $scope.$watch('date.start', function (val) {
    if (val != null && $scope.parametersData) {
      for (let i = 0; i < $scope.parametersData.length; i++) {
        if (
          $scope.parametersData[i]._selected &&
          $scope.parametersData[i].name === 'drop_DateRange'
        ) {
          $scope.isValid.dateDrop = false;
        }

        if ($scope.parametersData[i].name === 'dt_StartDate') {
          $scope.parametersData[i]._selected = moment(val).format(DATE_FORMAT);
          $scope.isValid.startDate = $scope.isValid.endDate =
            $scope.date.start && $scope.date.end ? $scope.date.end >= $scope.date.start : false;
          if ($scope.reportForm && $scope.reportForm.dt_StartDate) {
            $scope.reportForm.dt_StartDate.$error.dateGreaterThan = $scope.isValid.startDate;
          }
        }
      }
    }
  });

  $scope.allowViewReportAndExport = function () {
    let allow = $scope.requiredFieldsFilled();
    if (
      allow &&
      $scope.selectedAttributes.dateRange &&
      $scope.selectedAttributes.dateRange.label === 'Custom'
    ) {
      allow =
        allow &&
        $scope.date.start &&
        $scope.date.end &&
        $scope.isValid.endDate &&
        $scope.isValid.startDate;
    }
    return allow;
  };

  $scope.csvFormValidation = function () {
    if ($scope.csvForm.dt_StartDate) {
      $scope.csvForm.dt_StartDate.$touched = true;
    }
    if ($scope.csvForm.dt_EndDate) {
      $scope.csvForm.dt_EndDate.$touched = true;
    }
    const valid =
      $scope.selectedAttributes.selectedAssets.length > 0 &&
      $scope.allowViewReportAndExport() &&
      $scope.csvReport.contacts.length > 0 &&
      $scope.csvReport.contacts.length <= 10 &&
      $scope.numSelectedDataPoints() > 0 &&
      $scope.validDateRange(90);
    return valid;
  };

  // modal overlay create schedule
  $scope.createSchedule = () => {
    // check for selected assets if assetList present as report param
    if (
      !$scope.selectedAttributes.reportDoesNotRequireAssets &&
      !($scope.selectedAttributes.selectedAssets.length > 0)
    ) {
      return;
    }

    $scope.selectedAttributes.reportName = $scope.reportName;
    // get report parameters and populate their values
    $scope.parametersData.forEach((value) => {
      switch (value.name) {
        case 'AssetList':
          break;
        case 'date_PickRange':
          break;
        case 'dt_StartDate':
          break;
        case 'dt_EndDate':
          if ($scope.dateRangeType.indexOf('Weekly') !== -1) {
            $scope.selectedAttributes.reportParameters[value.name] = $scope.date.end;
          }
          break;
        case 'drop_DateRange':
          if (!$scope.dateRangeType.indexOf('Weekly') !== -1) {
            $scope.selectedAttributes.reportParameters[value.name] = value.name;
          }
          break;
        case ParamterNames.Plant:
          $scope.selectedAttributes.reportParameters[value.name] = value._selected;
          break;
        default:
          $scope.selectedAttributes.reportParameters[value.name] = value.name;
          break;
      }
    });

    const modalInstance = $uibModal.open({
      animation: true,
      keyboard: false,
      backdrop: 'static',
      template: require('../jobschedules/job/job.create.html'),
      controller: 'JobCreateController',
      size: 'lg',
      resolve: {
        scheduleAttributes() {
          return $scope.selectedAttributes;
        },
      },
    });

    modalInstance.result.then(
      function (scheduleAttributes) {
        $scope.selectedAttributes.selectedAssets = scheduleAttributes.selectedAssets;
        $scope.selectedAttributes.dateRange = scheduleAttributes.dateRange;
        $scope.$broadcast('refreshSchedules', true);
      },
      function () {
        $scope.$broadcast('refreshSchedules', true);
      },
    );
  }; // end modal overlay create schedule

  $scope.checkNumberOfAssets = function () {
    if ($scope.selectedAttributes.selectedAssets.length <= 0) {
      $scope.errorMessage = true;
    }
  };

  /** ---modal overlay select data points --- */
  $scope.selectDataPoints = function () {
    let flag = false;
    if ($scope.maxSelection === 1) {
      flag = true;
    }
    const modalInstance = $uibModal.open({
      animation: true,
      template: require('./datapointspicker/datapoint.multi.picker.html'),
      controller: 'DatapointMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: flag,
        includeDiagnosticDatapoints: $scope.report.name === 'Current Asset Data',
        maxSelection() {
          return $scope.maxSelection;
        },
        assetsSelected: $rootScope.assetsSelected,
        selectedDatapoints() {
          return $rootScope.datapointsSelected;
        },
      },
    });

    modalInstance.result
      .then(function (selectedDatapoints) {
        $rootScope.datapointsSelected = selectedDatapoints;
      })
      .catch(() => {});
  }; // end modal overlay for selecting data points

  // Added modal for the Hourly Asset Utilization
  $scope.clickedDatapointModal = function () {
    // Get equipment datapoints
    const parameterDatapoints = $scope.getDatapointsFromParameters();
    const assetIds = $scope.getSingleSelectedEquipment();
    if (!assetIds) return;


    const modalInstance = $uibModal.open({
      animation: true,
      template: DatapointSelectorHtml,
      controller: DatapointSelectorController,
      controllerAs: 'datapointSelectorVm',
      size: 'lg',
      resolve: {
        datapointListCallback: () => {
          return () => {
            return reportingService.getDatapointsAndFilter(assetIds, parameterDatapoints);
          };
        },
        preSelectedDatapoints: () => $rootScope.datapointsSelected,
        maxSelection: () => 10,
      },
    });

    modalInstance.result
      .then((selectedDatapoints) => {
        $rootScope.datapointsSelected = selectedDatapoints;
        $rootScope.datapointIdsSelected = selectedDatapoints.map((datapoint) => {
          return datapoint.dataId;
        });
      })
      .catch((error) => { });
    $scope.isDirty = true;
  };

  $scope.getDatapointsFromParameters = () => {
    const { validValues } =
      $scope.parametersData.find((param) => param.name === ParamterNames.Datapoint) || [];
    return validValues.map((validValue) => validValue.value);
  };

  $scope.getSingleSelectedEquipment = () => {
    const assetIds = Object.keys($rootScope.assetsSelected);
    return assetIds || [];
  };

  $scope.numSelectedDataPoints = () => {
    return Object.keys($rootScope.datapointsSelected || {}).length;
  };
  $scope.csvGenerating = false;

  $scope.generateCSV = function () {
    if (!$scope.csvFormValidation()) {
      $scope.errorMessage = true;
      return;
    }
    $scope.error = false;
    $scope.csvGenerating = true;
    $scope.csvGenerated = false;
    CSVDataExportService.createCSV(gatherCSVData()).then(
      function () {
        $scope.csvGenerated = true;
      },
      function () {
        // In the case of an error...it should show an error message to the end user
        $scope.error = true;
      },
    );
  };

  $scope.validDateRange = function (offset) {
    if ($scope.date.start && $scope.date.end) {
      const fromDate = moment($scope.date.start);
      const toDate = moment($scope.date.end);
      const range = moment().range(fromDate, toDate);
      const diff = range.diff('days');

      if (diff > offset) {
        return false;
      }
      return true;
    }
    return true;
  };

  function setDateRange(offset) {
    const todayMinusOffset = moment().subtract(offset, 'days');
    $scope.date.start = todayMinusOffset;
    $scope.date.end = moment();
  }

  function getDateRangeForCSVExport(paramSelected) {
    switch (paramSelected.id) {
      case '1': // 7d
        setDateRange(7);
        break;
      case '2': // MTD
      case '3': // 30d
        setDateRange(30);
        break;
      case '4': // 90d
        setDateRange(90);
        break;
      default:
        break;
    }
  }
  function getDateRangeString() {
    if ($scope.date && $scope.date.start && $scope.date.end) {
      const startDate = moment($scope.date.start).format(DATE_FORMAT);
      const endDate = moment($scope.date.end).format(DATE_FORMAT);
      return `${startDate}/${endDate}`;
    }
    return undefined;
  }

  function gatherCSVData() {
    if ($scope.selectedAttributes.dateRange) {
      getDateRangeForCSVExport($scope.selectedAttributes.dateRange);
    }
    const csv = {};

    const data = {
      email: [...$scope.csvReport.contacts.map((contact) => contact.email)],
      range: getDateRangeString(),
      equipment: (function () {
        const arr = [];
        angular.forEach($scope.selectedAttributes.selectedAssets, function (asset) {
          if (typeof asset === 'string') {
            arr.push(asset);
          } else {
            arr.push(asset.id);
          }
        });
        return arr;
      })(),
      datapoint: (function () {
        const arr = [];
        angular.forEach(Object.keys($rootScope.datapointsSelected), function (datapoint) {
          arr.push(datapoint);
        });
        return arr;
      })(),
    };
    csv.data = data;
    return csv;
  }
}
